// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"edec54d8","423":"9fded506","454":"2c31ebef","568":"b4bc48cb","787":"8ce559cc","987":"d36f676f"}[chunkId] + ".chunk.js";
};